import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./EquipmentsListModal.css";
import { CreateEquipments, CreateRoom, CreateScenario } from "../../api/api";
import SuccessToast from "../toasts/SuccessToast";
import { useNavigate } from "react-router-dom";
import ErrorToast from "../toasts/ErrorToast";

const RoomNameModal = ({}) => {
  const { setRoomNameModal, rooms, setRooms, setIsLoading } =
    useContext(Context);
  const [roomName, setRoomName] = useState("");
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setRoomNameModal(modalName);
  }, []);

  const handleAddRoom = () => {
    if (roomName == "" || roomName == null) {
      return ErrorToast("نام اتاق را وارد کنید");
    }

    setIsLoading(true);
    CreateRoom({
      name: roomName,
    })
      .then(({ data }) => {
        if (roomName.trim()) {
          setRooms((prevRooms) => [
            ...prevRooms,
            { id: data.room.id, name: roomName },
          ]);
          setRoomName("");
          //   setAddingRoom(false);
          SuccessToast("اتاق با موفقیت ایجاد شد");
        }
      })
      .catch((err) => {})
      .finally(() => {
        closeButton.current.click();
        setIsLoading(false);
      });
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentsName"
      tabIndex="-1"
      aria-labelledby="equipmentsNameLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              انتخاب نام اتاق
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="roomName" className="form-label">
                نام اتاق را وارد کنید
              </label>
              <input
                type="text"
                className="form-control"
                id="roomName"
                value={roomName}
                onChange={(e) => setRoomName(e.target.value)}
              />
            </div>
            <div>
              
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
                type="button"
                className="btn btn-success-app me-3 mb-2"
                onClick={handleAddRoom}
              >
                تایید
              </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomNameModal;
